<template>
    <div>
        <dashboard-authorized v-if="isLoggedIn"></dashboard-authorized>
        <dashboard-guest v-if="! isLoggedIn"></dashboard-guest>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    import DashboardAuthorized from "./DashboardAuthorized";
    import DashboardGuest from "./DashboardGuest";

    export default {
        components: {
            DashboardGuest,
            DashboardAuthorized,
        },
        computed: {
            ...mapGetters('auth', [
                'isLoggedIn'
            ])
        }
    }
</script>
